import React, { useState } from 'react'
import ContainerLayout from '../../../components/container-layout/ContainerLayout';
// import { RoutePath } from '../../../routes/Routes';
import StateComponents from '../../../components/state-component/StateComponents';
import { useNavigate, useParams } from 'react-router-dom';
import ModalMedia from '../media/modal-media/ModalMedia';
import { linkPreviewImage } from '../../../components/upload-image-preview/UploadImagePreview';
// import { STATUS_ENUM } from '../../manage-articles/enum/article.enum';
import ContainerButton from '../../../components/button/ContainerButton';
import { ManageStateDetail } from './manageStateDetail';
import { STATUS_ENUM } from '../website-structure/content/enum/content.enum';
import { Button } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import VdoUploadContent from '../collections/element/VdoUploadContent';

type Props = {
    view?: boolean;
}

const ContentAdmission: React.FC<Props> = ({ view }: Props) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [is_copy, set_is_copy] = useState<boolean>(false);

    const {
        formState,
        handleChangeFormState,
        handleSubmit,
        errorMessage,
        id_media_file,
        set_file_api_url,
        set_id_media_file,
        showModal,
        setFormState,
        handleCloseModal,
        image_api,
        handleChangeImageApi,
        setShowModal,
        handleDeleteImageApi,
        content_no,
        vdo_data,
        set_vdo_data,
        handleDeleteImage,
        handleUploadVdo,
        handleDeletedVdoFile,
        checkPermit
    } = ManageStateDetail();

    return (
        <ContainerLayout
            title=''
            titleName={"Admission"}
            navigateContent={
                <></>
            }
            buttonContent={
                <div className='w-full flex justify-end items-center gap-2'>
                    <StateComponents
                        typeProps={[
                            {
                                seq: 1,
                                gridProps: {
                                    xs: 12
                                },
                                hidden: formState.status === STATUS_ENUM.DRAFT || !id,
                                type: "TEXT_FIELD",
                                fieldProps: {
                                    value: content_no,
                                    placeholder: 'ลิ้งเชื่อมโยง',
                                    endAdornment: <Button sx={{
                                        width: is_copy ? 240 : 150,
                                        opacity: is_copy ? .4 : 1,
                                        textTransform: 'none',
                                        transition: 'all .1s ease'
                                    }} variant='contained' startIcon={<ContentCopyIcon />} onClick={() => {
                                        set_is_copy(true);
                                        navigator.clipboard.writeText(content_no).then(() => {
                                            setTimeout(() => {
                                                set_is_copy(false)
                                            }, 1000)
                                        });
                                    }}>{is_copy ? 'loading..' : 'คัดลอก'}</Button>,
                                    onChange: () => { }
                                }
                            }
                        ]}
                    />
                    <ContainerButton
                        justifyContent='flex-end'
                        sxContainer={{ maxWidth: "fit-content" }}
                        buttonData={[
                            {
                                key: "BACK",
                                buttonProps: {
                                    disabled: window.history.length === 0,
                                    onClick: () => navigate(-1)
                                },
                                label: "ย้อนกลับ",
                                seq: 1,
                                type: "BACK"
                            },
                            {
                                key: "SAVE",
                                hidden: view || !checkPermit.isUpdate,
                                buttonProps: {
                                    onClick: () => {
                                        handleSubmit("SUBMIT");
                                    }
                                },
                                label: "บันทึก",
                                seq: 3,
                                type: "SAVE"
                            },
                        ]}
                    />
                </div>
            }
            content={
                <div className='w-full'>
                    <StateComponents
                        disabledAllField={view || !checkPermit.isView}
                        otherProps={{ spacing: 2 }}
                        typeProps={[
                            {
                                seq: 1,
                                type: "SWITCH",
                                gridProps: {
                                    xs: 12
                                },
                                fieldProps: {
                                    disabled: view,
                                    checked: formState.is_public ? true : false,
                                    onChange: (val) => handleChangeFormState('is_public', val ? 1 : 0),
                                    label: "สถานะการเผยแพร่"
                                }
                            },
                            // {
                            //     seq: 2,
                            //     type: "DATE",
                            //     gridProps: {
                            //         xs: 12,
                            //         md: 3
                            //     },
                            //     fieldProps: {
                            //         helperText: errorMessage.content_start_date,
                            //         required: true,
                            //         onChange: (date) => handleChangeFormState('content_start_date', date),
                            //         value: formState.content_start_date,
                            //         heading: "วันที่เริ่มต้นเผยแพร่",
                            //         placeholder: "ระบุ"
                            //     }
                            // },
                            // {
                            //     seq: 3,
                            //     type: "DATE",
                            //     gridProps: {
                            //         xs: 12,
                            //         md: 3
                            //     },
                            //     fieldProps: {
                            //         helperText: errorMessage.content_end_date,
                            //         required: true,
                            //         disabled: view || !formState.content_start_date,
                            //         disableStartDate: formState.content_start_date,
                            //         onChange: (date) => handleChangeFormState('content_end_date', date),
                            //         value: formState.content_end_date,
                            //         heading: "วันที่สิ้นสุดเผยแพร่",
                            //         placeholder: "ระบุ"
                            //     }
                            // },
                            // {
                            //     seq: 4,
                            //     type: "TIME_PICKER",
                            //     gridProps: {
                            //         xs: 12,
                            //         md: 3
                            //     },
                            //     fieldProps: {
                            //         helperText: errorMessage.content_start_time,
                            //         required: true,
                            //         value: formState.content_start_time,
                            //         onChange: (e) => handleChangeFormState('content_start_time', e),
                            //         heading: "เวลาที่เริ่มต้นเผยแพร่",
                            //         placeholder: "ระบุ"
                            //     }
                            // },
                            // {
                            //     seq: 5,
                            //     type: "TIME_PICKER",
                            //     gridProps: {
                            //         xs: 12,
                            //         md: 3
                            //     },
                            //     fieldProps: {
                            //         helperText: errorMessage.content_end_time,
                            //         required: true,
                            //         value: formState.content_end_time,
                            //         onChange: (e) => {
                            //             handleChangeFormState('content_end_time', e)
                            //         },
                            //         heading: "เวลาที่สิ้นสุดเผยแพร่",
                            //         placeholder: "ระบุ"
                            //     }
                            // },
                        ]}
                    />
                    {/* <div className='w-full my-10'>
                        <BannerTypeContent
                            value={formState.banner_type}
                            disabled={view}
                            onClick={(val) => !view && handleChangeFormState('banner_type', val)}
                        />
                    </div>
                    <div className='w-full shadow-md p-4 my-10'>
                        <StateComponents
                            typeProps={[
                                {
                                    seq: 1,
                                    type: "MULTI_UPLOAD_IMAGE",
                                    gridProps: {
                                        xs: 12
                                    },
                                    fieldProps: {
                                        handleDeleteImageApi: (_, i) => handleDeleteImageApi(i),
                                        handleDeleteImageSelect: () => { },
                                        onChange: () => { },
                                        tabIndex: 2,
                                        valueAddFile: [],
                                        heading: 'ไฟล์แบนเนอร์',
                                        onUploadMedia: () => {
                                            setShowModal("ADD")
                                        },
                                        is_using_modal_media: true,
                                        disabled: view,
                                        addImageIcon: <IconComponents.UploadImageFileIcon />,
                                        valueImage: image_api || []
                                    }
                                },
                            ]}
                        />
                    </div> */}
                    <VdoUploadContent
                        required
                        handleDeleteByIndex={(index, obj) => {
                            if (obj?.id_content_vdo_file) {
                                handleDeletedVdoFile(obj?.id_content_vdo_file);
                            } else {
                                handleDeleteImage(index)
                            }
                        }}
                        disabled={vdo_data?.length === 1}
                        onVdoUploadOtherApi={(file) => {
                            handleUploadVdo(file);
                        }}
                        vdo_data={vdo_data?.map((list) => {
                            return {
                                ...list,
                                created_date: list?.modified_date,
                                gallery_link: list?.link || "",
                                id_media_file: list?.id_media_file,
                                media_file_name: list?.file_name,
                                media_file_path: list?.file_path,
                                media_file_size: list?.media_file_size || ""
                            }
                        })}
                        onUploadChange={(data) => {
                            set_vdo_data((prev) => ([...prev, {
                                id_media_file: data?.id_media_file,
                                media_file_name: data?.media_file_name,
                                media_file_path: data?.media_file_path,
                                gallery_link: "",
                            }]))
                        }}
                        onLinkChange={(link) => {
                            set_vdo_data((prev) => ([...prev, {
                                id_media_file: null,
                                media_file_name: "",
                                media_file_path: "",
                                link,
                            }]))
                        }}
                    />
                    <div className='w-full grid grid-cols-12 gap-4 mt-6'>
                        <span className='col-span-12'>
                            <StateComponents
                                otherProps={{ spacing: 3 }}
                                disabledAllField={view}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                        },
                                        fieldProps: {
                                            disabled: view,
                                            required: true,
                                            helperText: errorMessage.content_name,
                                            heading: 'หัวข้อข่าว',
                                            placeholder: 'ระบุ',
                                            value: formState.content_name,
                                            onChange: (e) => handleChangeFormState('content_name', e.target.value)
                                        }
                                    },
                                    // {
                                    //     seq: 2,
                                    //     type: "TEXT_FIELD",
                                    //     gridProps: {
                                    //         xs: 12,
                                    //     },
                                    //     fieldProps: {
                                    //         disabled: view,
                                    //         heading: 'ข้อความย่อย',
                                    //         placeholder: 'ระบุ',
                                    //         value: formState.content_desc,
                                    //         onChange: (e) => handleChangeFormState('content_desc', e.target.value)
                                    //     }
                                    // },
                                    {
                                        seq: 3,
                                        type: "TEXT-EDITOR",
                                        gridProps: {
                                            xs: 12,
                                        },
                                        fieldProps: {
                                            disabled: view,
                                            heading: 'รายละเอียด',
                                            placeholder: 'ระบุ',
                                            textString: formState.content_detail,
                                            onChange: (e) => {
                                                handleChangeFormState('content_detail', e);
                                            }
                                        }
                                    },
                                    // {
                                    //     seq: 4,
                                    //     type: "TEXT-EDITOR",
                                    //     gridProps: {
                                    //         xs: 12,
                                    //     },
                                    //     fieldProps: {
                                    //         disabled: view,
                                    //         heading: 'ข้อกำหนดและเงื่อนไขในการเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคล',
                                    //         placeholder: 'ระบุ',
                                    //         textString: formState.content_desc,
                                    //         onChange: (e) => {
                                    //             handleChangeFormState('content_desc', e);
                                    //         }
                                    //     }
                                    // }
                                ]}
                            />
                        </span>
                    </div>

                    {showModal !== "" && (
                        <ModalMedia
                            open
                            handleClose={handleCloseModal}
                            title='เพิ่มไฟล์'
                            id_media_file={id_media_file}
                            multiple
                            onSelectMediaFile={(_, id) => set_id_media_file(id)}
                            onSubmitMediaFile={async (_, id_media_file) => {
                                handleCloseModal();
                                const path = await linkPreviewImage(id_media_file);
                                set_file_api_url(path);
                                setFormState((prev) => ({ ...prev, id_media_file }))
                                // handleSubmit(id_media_file);
                            }}
                            onSubmitMediaFileMultiple={(media_file) => {
                                handleChangeImageApi(media_file)

                            }}
                            onSubmitLocalFile={async (id_media_file) => {
                                const path = await linkPreviewImage(id_media_file);
                                setFormState((prev) => ({ ...prev, id_media_file }))
                                set_file_api_url(path);
                                handleCloseModal();
                                // handleSubmit(id_media_file);
                            }}
                        />
                    )}
                </div>
            }
        />
    )
}

export default ContentAdmission